import React, { useEffect } from 'react';
import AlignTextLeftIcon from '@atlaskit/icon/core/align-text-left';
import { FormattedMessage } from '@atlassian/jira-intl';
import ButtonMenuItemWithAnalytics from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-common-core/src/common/ui/button-menu-item-with-analytics/index.tsx';
import { getProjectMenuItemAnalytics } from '@atlassian/jira-navigation-apps-sidebar-nav4-sidebars-content-projects-common/src/common/utils/analytics.utils.tsx';
import { useSwitchModals } from '@atlassian/jira-switch-modals-controller/src/index.tsx';
import { MODAL_ID } from '@atlassian/jira-atlassian-navigation/src/common/constants.tsx';
import { useAnalyticsEvents, fireUIAnalytics } from '@atlassian/jira-product-analytics-bridge';
import messages from './messages.tsx';

export const BrowseTemplatesMenuItem = () => {
	const [, { on: openProjectCreateDrawer }] = useSwitchModals(MODAL_ID.PROJECT_CREATE);
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const browseTemplatesAnalytics = getProjectMenuItemAnalytics({
		itemId: 'browseTemplates',
	});

	useEffect(() => {
		fireUIAnalytics(
			createAnalyticsEvent({
				action: 'viewed',
				actionSubject: 'browseTemplateButton',
			}),
		);
	}, [createAnalyticsEvent]);

	return (
		<ButtonMenuItemWithAnalytics
			onClick={openProjectCreateDrawer}
			elemBefore={<AlignTextLeftIcon label="" color="currentColor" />}
			analytics={browseTemplatesAnalytics}
		>
			<FormattedMessage {...messages.browseTemplates} />
		</ButtonMenuItemWithAnalytics>
	);
};
